
<script>
import { mapGetters, mapActions } from "vuex";
import L from "leaflet";
import "leaflet-toolbar";
import "leaflet-distortableimage";
import kz from "../../kz.json";
import Sidebar from "../components/sidebar/Sidebar";
import Login from "../components/login/Login";
import ActionsBar from '../components/actions-bar/ActionsBar'
import 'leaflet-wms-header'
import axios from "axios";

export default {
  data: {
    displayActions: true,
  },
  name: "Map",
  components: { Sidebar, Login, ActionsBar },
  data() {
    return {
      map: null,
      latlng: [47.2286086, 65.2093197],
      zoom: 8,
      loading: true,
      selectedLayer: new L.LayerGroup(),
      isLayerSelected: false,
      range: 1,
      currentGrid: [],
      polygons: [],
      kmlfile: null,
    };
  },
  watch: {
    isAuthenticated: function (val) {
      this.getLayers()
    },
    "$root.displaybuttons": function (val) {
      this.polygons = []
      this.$root.globalgrid = []
      this.selectedLayer.clearLayers();
      this.isLayerSelected = false
    },
    grid: async function (val) {
      // this.loading = false
      
      if (this.grid.length>0) {
        console.log(this.grid)
        this.polygons = []
        this.$root.globalgrid = []
        // console.log(this.grid[0].geometry.coordinates[0])
        if (this.$root.curLayer){
        await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images/{images_id}/secret_zones?image_id=${this.$root.curLayer}`).then((e) => {
        for (let i=0; i < this.grid.length; i++) {
          let coordinates = this.grid[i].geom_raw.coordinates[0];
          // .addTo(this.state.drawnItems);
          let polygon = L.polygon([
            L.latLng(parseFloat(coordinates[0][1]), parseFloat(coordinates[0][0])),
            L.latLng(parseFloat(coordinates[1][1]), parseFloat(coordinates[1][0])),
            L.latLng(parseFloat(coordinates[2][1]), parseFloat(coordinates[2][0])),
            L.latLng(parseFloat(coordinates[3][1]), parseFloat(coordinates[3][0])),
          ]);
          this.$root.globalgrid_temp.push(JSON.stringify(polygon.toGeoJSON()))
          // .addTo(this.state.drawnItems);
          let is_secret = false
          e.data.forEach((j) => {
            if (this.grid[i].id == j.secret_zone_id){
              is_secret = true
            }
          })
          let grid_id = JSON.parse(JSON.stringify(this.grid))[i].id
          // polygon.grid_id = grid_id
          polygon.addEventListener('click', () => this.handlePolygonClick(polygon, grid_id))
          this.$root.globalgrid.push(polygon.toGeoJSON())
          // this.map.on('click', this.handlePolygonClick(polygon))
          if (!this.$root.concealgrid){
          let options = {
            stroke: true,
            color: "#4185f4",
            weight: 3,
            opacity: 1,
            fill: true,
            fillColor: "#ff0000",
            fillOpacity: is_secret && !this.$root.displaybuttons ? 0.3 : 0,
            clickable: true
          };
          polygon.setStyle(options);
          this.selectedLayer.addLayer(polygon);
          this.selectedLayer.addTo(this.map)
          }
          }
          })
        } else {
          for (let i=0; i < this.grid.length; i++) {
          let coordinates = this.grid[i].geom_raw.coordinates[0];
          // .addTo(this.state.drawnItems);
          let polygon = L.polygon([
            L.latLng(parseFloat(coordinates[0][1]), parseFloat(coordinates[0][0])),
            L.latLng(parseFloat(coordinates[1][1]), parseFloat(coordinates[1][0])),
            L.latLng(parseFloat(coordinates[2][1]), parseFloat(coordinates[2][0])),
            L.latLng(parseFloat(coordinates[3][1]), parseFloat(coordinates[3][0])),
          ]);
          this.$root.globalgrid_temp.push(JSON.stringify(polygon.toGeoJSON()))
          this.$root.globalgrid.push(polygon.toGeoJSON())
          }
        }
      }
    },
  },
  created() {},
  mounted() {
    this.initMap();
    this.initListeners();
    this.getLayers()
  },
  computed: {
    ...mapGetters(["isAuthenticated", "layers", "grid"]),
  },
  methods: {
    ...mapActions(["getLayers", "setCurrentLayer"]),
    initMap() {
      this.map = L.map("map", {
        minZoom: 2,
        zoomControl: false,
        opacity: 0
      }).setView(this.latlng, this.zoom);
      this.map.attributionControl.setPrefix(
        '<a href="https://gharysh.kz/">АО НК "Қазақстан Ғарыш Сапары"</a>'
      );
      L.control
        .zoom({
          position: "topright"
        })
        .addTo(this.map);
      let mapBounds = L.latLngBounds([
        [90, -180],
        [-90, 180]
      ]);
      this.map.setMaxBounds(mapBounds);
      L.geoJSON(kz, { fillOpacity: 0 }).addTo(this.map);
      this.setLayer();
      this.map.whenReady(() => {
        this.loading = false;
      });
      this.selectedLayer.addTo(this.map);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

    },

    async setLayer() {
      // let firstLayer = await L.tileLayer(
      //   "http://10.0.11.70:8080/maps/militarysecrettiles/DS_DZHR1_202010080712050_KZ1_E055N51_004285_PR_1/{z}/{x}/{y}.png",
      //   {tms: true, opacity: 1, attribution: "", minZoom: 5, maxZoom: 18}
      // );
      // firstLayer.addTo(this.map);
      this.map.locate({setView: true, maxZoom: 8, minZoom:5});
    },

    initListeners() {
      this.eventBus.$on("layerClicked", (layer, show) => {
        this.polygons = []
        this.$root.globalpolygons = {}
        this.$root.curLayer = layer.id
        this.selectedLayer.clearLayers();
        this.isLayerSelected = false;
        this.range = 1;
         if (layer) {
          this.isLayerSelected = true
          this.setCurrentLayer(layer)
          let coordinates = layer.geom_raw.coordinates[0];
          // .addTo(this.state.drawnItems);
          let polygon = L.polygon([
            L.latLng(parseFloat(coordinates[0][1]), parseFloat(coordinates[0][0])),
            L.latLng(parseFloat(coordinates[1][1]), parseFloat(coordinates[1][0])),
            L.latLng(parseFloat(coordinates[2][1]), parseFloat(coordinates[2][0])),
            L.latLng(parseFloat(coordinates[3][1]), parseFloat(coordinates[3][0])),
          ]);
          // .addTo(this.state.drawnItems);
          let options = {
            stroke: true,
            color: "#4185f4",
            weight: 3,
            opacity: 1,
            fill: true,
            fillColor: null,
            fillOpacity: 0,
            clickable: true
          };
          polygon.setStyle(options);

          console.log(layer)
          // let selectedTileLayer = L.TileLayer.wmsHeader(
          //   // "http://10.0.11.70/" + layer.tile_service+ "/{z}/{x}/{y}.png",
          //   layer.tile_service_local_url+"/{z}/{x}/{y}.png",
          //   {
          //     opacity: 1,
          //     tms: true,
          //     attribution: "", 
          //     minZoom: 5, 
          //     maxZoom: 18,
          //     format: 'image/png',
          //     service: 'tms'
          //   },
          //   [
          //     { header: 'Authorization', value: `Bearer ${sessionStorage.token.slice(1,-1)}`},
          //     // { header: 'content-type', value: 'text/plain'},
          //   ],
          //   null
          // );
           let selectedTileLayer = L.tileLayer(
            layer.tile_service_local_url+ "/{z}/{x}/{y}.png",
            {tms: true, opacity: 1, attribution: "", minNativeZoom: layer.min_zoom_local, maxNativeZoom: layer.max_zoom_local}
           )
          this.selectedLayer.addLayer(selectedTileLayer)

          polygon.code = layer.code;
        !show &&
          this.map.flyTo(new L.LatLng(parseFloat(coordinates[3][1]),parseFloat(coordinates[0][0])), 10);
        }
      });
    },
    setSelectedLayerOpacity(e) {
      // console.log(e.target);
      this.selectedLayer
        .getLayers()
        .find(l => !l.code)
        .setStyle({
          opacity: this.range
        });
    },
    layerSelected(layer) {
      this.$root.curLayer = layer
      this.eventBus.$emit("layerForGrid", layer);
    },
    async handlePolygonClick(polygon, fieldid) {
      var check = false
      await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v1/images/{images_id}/secret_zones?image_id=${this.$root.curLayer}`).then((e) => {
          e.data.forEach((j) => {
            if (fieldid == j.secret_zone_id){
              check = true
            }
          })
      })
      let bearerToken = ""
      if (this.$root.displaybuttons) {
      if(sessionStorage.token) {
        bearerToken = JSON.parse(sessionStorage.token)
      } else {
        bearerToken = this.token
      }
      JSON.parse(JSON.stringify(this.polygons)).forEach(e => {
        if (JSON.stringify(JSON.parse(e).geometry) == JSON.stringify(polygon.toGeoJSON().geometry)) {
          check = true
        }
      });
      if (!check) {
      var m = eval(JSON.stringify(this.polygons))
      polygon.setStyle({
        fillColor: '#ff0000',
        fillOpacity: 0.3
      })
      var polygonJSON = polygon.toGeoJSON()
      var layer = JSON.parse(JSON.stringify(this.$root.curLayer))
      polygonJSON.properties.is_secret = '+'
      polygonJSON.properties.grid_cell_id = fieldid
      polygonJSON.properties.image_id = this.$root.curLayer
      // polygonJSON.properties.image_id = imageid
      this.polygons.push(JSON.stringify(polygonJSON))
      await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.$root.curLayer}/secret_zones/${fieldid}`, {}, {
          headers: {
            Authorization: `Bearer ${bearerToken}`
          }
        })
      } else {
        polygon.setStyle({
        fillColor: '#000000',
        fillOpacity: 0
      })
      this.polygons = this.polygons.filter((e) => {
        return (JSON.stringify(JSON.parse(e).geometry) !== JSON.stringify(polygon.toGeoJSON().geometry))
      })
      await axios.delete(`${process.env.VUE_APP_BASE_URL}/api/v1/images${this.$root.curLayer}/secret_zones/${fieldid}`, {}, {
          headers: {
            Authorization: `Bearer ${bearerToken}`
          }
        })
      }
      this.$root.globalpolygons = JSON.parse(JSON.stringify(this.polygons))
    }
      // console.log("!!")
      // const point = turf.point([e.latlng.lng, e.latlng.lat])
      // dataTiles?.forEach(tile => {
      //   if (turf.booleanPointInPolygon(point, tile.geometry)) setActiveTile(tile)
      // })
    }
  },
  inject: ["eventBus"]
};
</script>

<style lang="scss">
#map {
  width: 100vw;
  height: 100vh;
  z-index: 1;
}
.loader {
  z-index: 1000;
}
.slider {
  position: absolute;
  max-width: 150px;
  background: white;
  bottom: 20px;
  right: 10px;
  z-index: 2;
  background: white !important;
  padding: 10px !important;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65) !important;
  border-radius: 4px !important;
}
#kmlbutton{
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 1000000;
}
</style>
<template>
  <div>
    <login v-if="!isAuthenticated" />
    <centered-loader v-if="loading" />
    <sidebar v-show="isAuthenticated"/>
    <!-- <b-form-input
      v-if="isLayerSelected && isAuthenticated"
      class="slider"
      min="0"
      max="1"
      step="0.1"
      type="range"
      v-model="range"
      @change="setSelectedLayerOpacity"
    ></b-form-input> -->
    <actions-bar class="actions-bar" v-if="isLayerSelected"/>
    <div id="map" />
  </div>
</template>